import React, { FC } from 'react';
import useLocalStorage from 'react-use-localstorage';
import { Redirect, Route, Switch } from 'react-router-dom';

import { RequireAuth } from './common/Auth';
import Airing from './airings/Airing';
import Airings from './airings/Airings';
import Channel from './channels/Channel';
import Channels from './channels/Channels';
import Composer from './highlights/Composer';
import Fer from './games/Fer';
import Game from './games/Game';
import Games from './games/Games';
import Highlight from './highlights/Highlight';
import LatestHighlight from './airings/LatestHighlight';
import Report from './report/Report';
import VideoDemo from './video/VideoDemo';

const Routes: FC = () => {
	const [item] = useLocalStorage('loginpath', '');

	return (
		<Switch>
			<RequireAuth>
				<Route exact path='/' render={(): JSX.Element => <Redirect to={item.indexOf('report') !== -1 ? '/report' : '/games'} />} />

				<Route exact path='/airings'>
					<Airings />
				</Route>
				<Route exact path='/airings/:id'>
					<Airing />
				</Route>
				<Route exact path='/airings/:id/edit'>
					<Airing edit='edit' />
				</Route>
				<Route exact path='/airings/:id/compose-highlight'>
					<Composer mode={'airing'} />
				</Route>
				<Route exact path='/airings/:id/editorial-highlight'>
					<Airing edit='editorialHighlight' />
				</Route>
				<Route exact path='/airings/:id/excluded-clips'>
					<Airing edit='exclusions' />
				</Route>
				<Route exact path='/airings/:id/latest-highlight'>
					<LatestHighlight />
				</Route>

				<Route exact path='/channels'>
					<Channels />
				</Route>
				<Route exact path='/channels/:id'>
					<Channel />
				</Route>
				<Route exact path='/channels/:id/edit'>
					<Channel edit={true} />
				</Route>

				<Route exact path='/games'>
					<Games />
				</Route>
				<Route exact path='/games/:gameId/fers/:ferId'>
					<Fer />
				</Route>
				<Route exact path='/games/:id'>
					<Game />
				</Route>
				<Route exact path='/games/:id/compose-highlight'>
					<Composer />
				</Route>
				<Route exact path='/games/:id/edit'>
					<Game edit='edit' />
				</Route>
				<Route exact path='/games/:id/editorial-highlight'>
					<Game edit='editorialHighlight' />
				</Route>
				<Route exact path='/games/:id/excluded-clips'>
					<Game edit='exclusions' />
				</Route>

				<Route exact path='/highlights/:id'>
					<Highlight />
				</Route>

				<Route exact path='/report'>
					<Report />
				</Route>
				<Route exact path='/video-demo'>
					<VideoDemo />
				</Route>
			</RequireAuth>
		</Switch>
	);
};

export default Routes;
